import { useCallback } from "react";
import { useVolWorkstationStore } from "../../../store/volWorkstationStore";
import { exportVolLayout, importVolLayoutFromFile } from "./volLayoutIo";

export function useVolWorkstationLayoutActions(curveId: string) {
  const exportDocument = useVolWorkstationStore((s) => s.exportDocument);
  const importDocument = useVolWorkstationStore((s) => s.importDocument);
  const resetToSeed = useVolWorkstationStore((s) => s.resetToSeed);

  const exportLayout = useCallback(() => {
    if (!curveId) return;
    exportVolLayout(exportDocument(curveId), curveId);
  }, [curveId, exportDocument]);

  const importLayout = useCallback(async () => {
    if (!curveId) return;
    try {
      const doc = await importVolLayoutFromFile();
      importDocument(curveId, doc);
    } catch {
      /* user cancelled or invalid file */
    }
  }, [curveId, importDocument]);

  const resetLayout = useCallback(() => {
    if (!curveId) return;
    const ok = window.confirm(`Reset vol workstation layout for "${curveId}" to defaults?`);
    if (ok) resetToSeed(curveId);
  }, [curveId, resetToSeed]);

  return {
    exportLayout,
    importLayout,
    resetLayout,
    canManage: !!curveId,
  };
}
